import { useState, useEffect, useRef } from "react";

type UseCountDownReturn = {
  secondsLeft: number;
  startCountDown: (seconds: number) => void;
  stopCountDown: () => void;
  resetCountDown: () => void;
};

function useCountDown(): UseCountDownReturn {
  const [secondsLeft, setSecondsLeft] = useState(0);
  const intervalId = useRef<NodeJS.Timeout | null>(null);

  const startCountDown = (seconds: number) => {
    setSecondsLeft(seconds);
  };

  const stopCountDown = () => {
    if (intervalId.current) {
      clearInterval(intervalId.current);
      intervalId.current = null;
    }
  };

  const resetCountDown = () => {
    stopCountDown();
    setSecondsLeft(0);
  };

  useEffect(() => {
    if (secondsLeft > 0) {
      intervalId.current = setInterval(() => {
        setSecondsLeft((seconds) => seconds - 1);
      }, 1000);
    } else {
      stopCountDown();
    }

    return () => {
      stopCountDown();
    };
  }, [secondsLeft]);

  return { secondsLeft, startCountDown, stopCountDown, resetCountDown };
}

export { useCountDown };
